<script>
  import { readable } from 'svelte/store'
  import { scale } from 'svelte/transition'
  import { quintOut } from 'svelte/easing'

  export let items = []

  $: operators = readable(
    [items.slice(0, 12), items.slice(12)],
    function (set, update) {
      let timeout = setTimeout(function loop() {
        timeout = setTimeout(loop, 1200)
        update(function ([visible, queue]) {
          let removes = Math.floor(Math.random() * visible.length)
          const _visible = visible.slice()
          const _queue = queue.slice()
          const [removed] = _visible.splice(removes, 1, _queue.shift())
          _queue.push(removed)
          return [_visible, _queue]
        })
      }, 1200)
      return () => clearTimeout(timeout)
    }
  )
</script>

<div class="inventory" aria-hidden="true">
  <ul class="list">
    {#each $operators[0] as item (item.src)}
      <li class="operator">
        <img
          in:scale={{ duration: 800, easing: quintOut, start: 1.4 }}
          src={item.src}
          draggable={false}
          width={item.width}
          height={item.height}
          alt={item.alt || ''}
          loading={item.lazy} />
      </li>
    {/each}
  </ul>
</div>

<style>
  .inventory {
    width: 100%;
    overflow: hidden;
    margin: 0 -1rem;
    width: calc(100% + 2rem);
    container-type: inline-size;
  }

  .list {
    display: grid;
    grid-template: 1fr 1fr 1fr 1fr / 1fr 1fr 1fr;
    user-select: none;
    pointer-events: none;
    flex-wrap: wrap;
    margin: 0 -1px -1px 0;
  }

  .operator {
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid rgba(var(--rgb-gray), 0.2);
    border-width: 0 1px 1px 0;
    position: relative;
    padding: 1.25rem 0;
  }

  .operator::before,
  .operator::after {
    content: '';
    width: 2rem;
    height: 2rem;
    background: var(--current-background);
    position: absolute;
    top: -1rem;
    left: -1rem;
  }

  .operator::after {
    inset: auto -1rem -1rem auto;
  }

  .operator img {
    height: 5.5cqw;
    min-height: 1.6rem;
    max-height: 2rem;
    width: auto;
  }

  @media (min-width: 600px) {
    .operator {
      padding: 1.5rem 0;
    }
  }

  @media (min-width: 800px) {
    .operator {
      padding: 1.5rem 0;
    }
  }

  @media (min-width: 1000px) {
    .operator {
      padding: 2rem 0;
    }
  }
</style>
